import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as moment from "moment";

@Pipe({
  standalone: false,
  name: 'bringozFullDate'
})
export class BringozFullDatePipe implements PipeTransform {

  constructor(@Inject("splitService") private splitService) {
  }

  transform(object?, ref?, defaultValue?, ignoreSite?): string {
    if (object && object[ref]) {
      const format = this.splitService.getDateAndTimeConfig(ignoreSite).fullDate;
      return moment(object[ref]).format(format);
    } else {
      return defaultValue;
    }
  }
}
